import { Stack } from '@mui/material';
import CheckoutWizard from '../../../components/displays/storeFront/checkout/CheckoutWizard';
import useCheckoutStore from '../../../stores/public/useCheckoutStore';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function StorefrontCheckout() {
  const { order, reservations } = useCheckoutStore();

  const navigate = useNavigate();

  useEffect(() => {
    if(order?.status === 'paid') {
      navigate(`/storefront/${order.organization_id}/order_confirmation`);
    }
  }, [order]);

  return (
    <Stack>
      <Stack px={{ xs: 0, sm: 2 }}>
        <CheckoutWizard order={order} reservations={reservations} />
      </Stack>
    </Stack>
  );
}